import { Box, Checkbox, FormControlLabel, Grid } from "@mui/material";
import * as React from "react";
import * as frontService from "../../../models/services/frontService";
import * as store from "../../../framework/customStore";
import { ConfirmationDialogResult } from "ui/Scripts/source/models/enums";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppUtils } from "../../../framework/appUtils";
import { SaveDataObj } from "../../../framework/saveData";
import { FilterButtons } from "../../framework/Filters/FilterButtons";
import { FormField } from "../../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/components/framework/FormField";
import { GridRow } from "../../framework/Grid/GridRow";
import { PageDrawer } from "../../framework/Page/PageDrawer";
import { AppSettingsIcon } from "source/components/framework/Icon/AppSettingsIcon";
import { IFrontPageMessages } from "source/models/front/frontPageMessages";
import { frontSetMessages } from "source/models/store/front";
import { IdTitleDropdown } from "ui/Scripts/source/components/framework/Dropdown/IdTitleDropdown";

export interface IFrontPanelMessagePropertiesDialogProp {
    classes?: string;
    title: string;
    panelSize: number;
    panelVisible: boolean;
    messages: IFrontPageMessages;
    hidePanelSize?: boolean;
    onSavePanelSize: (panelSize: number, panelVisible: boolean) => void;
    onClose: () => void;
}

export interface IFrontPanelMessagePropertiesDialogState {
    panelSize: string;
    panelVisible: boolean;
    dateRange: string;
}

export class FrontPanelMessagePropertiesDialog extends React.Component<IFrontPanelMessagePropertiesDialogProp, IFrontPanelMessagePropertiesDialogState> {
    private orgStateHash: string = "";

    constructor(props: IFrontPanelMessagePropertiesDialogProp) {
        super(props);
        this.state = {
            panelSize: props.panelSize.toString(10),
            dateRange: props.messages.dateRange.toString(10),
            panelVisible: props.panelVisible
        };
        //console.log(props.visible);
        
        const saveData = this.getSaveDataFromState(props, this.state);
        this.orgStateHash = saveData.hash;
    }

    changeVisibility = (panelVisible: boolean) => {
        this.setState({ panelVisible });
    };

    getSaveDataFromState = (props: IFrontPanelMessagePropertiesDialogProp, state: IFrontPanelMessagePropertiesDialogState): SaveDataObj => {
        const result = new SaveDataObj();
        result.append("dateRange", state.dateRange.toInteger());
        //Only for change detection - data is saved with separate operation
        result.append("panelSize", state.panelSize.toInteger());
        result.append("panelVisible", state.panelVisible);
        return result;
    };
    
    saveToDb = async () => {
        const props = this.props;
        const state = this.state;
        const saveData = this.getSaveDataFromState(props, state);
        //Call server
        const result = await AppUtils.callService(() => frontService.saveMessages(saveData.obj), false);
        if (!result) return;
        //Set app state
        store.customStore.dispatch(frontSetMessages(state.dateRange.toInteger()));
        //Close dialog
        props.onClose();
        //Save panel size
        props.onSavePanelSize(state.panelSize.toInteger(), state.panelVisible);
    };

    handleSave = () => {
        this.saveToDb();
    };

    handleCancel = async () => {
        const props = this.props;
        const state = this.state;
        const cancelResult = await AppUtils.cancel(this.getSaveDataFromState(props, state).hash, this.orgStateHash);
        if (cancelResult === ConfirmationDialogResult.Cancel) return;
        if (cancelResult === ConfirmationDialogResult.Yes) {
            this.saveToDb();
        } else {
            props.onClose();
        }
    };

    render() {
        const props = this.props;
        const state = this.state;
        return (
            <PageDrawer
                open
                icon={<AppSettingsIcon />}
                title={props.title}
                parentTitle={Translations.Panels}
                onClose={this.handleCancel}
            >
                <Box display="flex" flexDirection="column" flexGrow={2} margin="24px">
                    <Box display="flex" flexDirection="column" flexGrow={2}>
                        <GridRow>
                            <Grid item sm={12}>
                                <FormControlLabel
                                    label={Translations.PanelVisible}
                                    control={
                                        <Checkbox
                                            checked={state.panelVisible}
                                            onChange={(_e, checked) => this.changeVisibility(checked)}
                                        />
                                    }
                                />
                            </Grid>
                        </GridRow>
                        {!props.hidePanelSize &&
                            <GridRow>
                                <Grid item sm={6}>
                                    <FormField title={Translations.PanelSize}>
                                        <IdTitleDropdown
                                            selectedId={state.panelSize}
                                            items={[
                                                { id: "1", title: Translations.PanelSize1 },
                                                { id: "2", title: Translations.PanelSize2 },
                                                { id: "5", title: Translations.PanelSize5 },
                                                { id: "3", title: Translations.PanelSize3 },
                                                { id: "4", title: Translations.PanelSize4 },
                                                { id: "6", title: Translations.PanelSize6 }
                                            ]}
                                            onChange={(panelSize) => this.setState({ panelSize })}
                                        />
                                    </FormField>
                                </Grid>
                                <Grid item sm={6}>
                                    <FormField title={Translations.OldestMessage}>
                                        <IdTitleDropdown
                                            selectedId={state.dateRange}
                                            items={[
                                                { id: "0", title: Translations.DaysAgo30 },
                                                { id: "1", title: Translations.DaysAgo60 },
                                                { id: "2", title: Translations.DaysAgo90 },
                                                { id: "3", title: Translations.DaysAgo120 },
                                            ]}
                                            onChange={(dateRange) => this.setState({ dateRange })}
                                        />
                                    </FormField>
                                </Grid>
                            </GridRow>
                        }
                    </Box>
                    <FilterButtons
                        chartPanelPropertiesMode
                        onCancel={this.handleCancel}
                        onSave={this.handleSave}
                    />
                </Box>
            </PageDrawer>
        );
    }
}